import PublicationSuccess from './PublicationSuccess';
import AutoHelp from './AutoHelp'

const createAutoHelp = [
    {
        title: 'Enter your ad text',
        progress: { title: 'Auto help', step: 2 },
        component: AutoHelp, valid: true, required: true,
    },
    {
        progress: { title: 'Thank you', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createAutoHelp;
